import { clsx } from 'clsx'
import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { priceGetFormattedPrice } from '../../../../price'
import { type ProductReferencePriceType } from '../../../model/productAccessor/productAccessorReferencePrice'

import { ProductReferencePriceLabel } from './ProductReferencePriceLabel'

type ProductReferencePriceProps = {
  className: string
  priceToShow: number
  referencePriceType: ProductReferencePriceType | null
}

export const ProductReferencePrice: FC<ProductReferencePriceProps> = ({
  className,
  priceToShow,
  referencePriceType,
}) => {
  const intl = useIntl()

  return (
    <div className={clsx('text-s text-dark-primary-strong', className)}>
      <span data-qa-id="product-old-price">
        <ProductReferencePriceLabel referencePriceType={referencePriceType} />{' '}
        {priceGetFormattedPrice(priceToShow, intl)}
      </span>
    </div>
  )
}
